// InvoicePayment as a seperate class from Paymnet.model
// :: @https://nehalist.io/working-with-models-in-angular/ great tutorial and explianation of models and classes in angular.

import {Deserializable} from './deserializable.model';

export class WorkOrderPayment implements Deserializable<WorkOrderPayment> {
    work_order_payment_id: number;
    work_order_id: number;
    spending_id: number;
    spending_amount: number;
    work_order_number: string;
    subject_id: number;
    subject_number: string;
    job_id: number;
    job_number: string;
    spending_date: string;
    myob_account_code_id?: number;
    myob_bank_account_code_id?: number;
    from_brand_id?: number; // who the spendings will be appled to. (who the spending is from)
    to_brand_id?: number; // who the spendings will be appled to. (who the spending is from)
    spending_total?: number;
    remaining_total?: number;
    work_order_total?: number;
    created_by?: number;
    created_date?: string;
    updated_by?: number;
    updated_date?: string;
    
    deserialize(input: any): WorkOrderPayment {
      Object.assign(this, input);
      return this;
    }

  }


  /*
    invoice_payment_id
    invoice_id
    payment_id
    payment_amount
    invoice_number
    subject_id
    subject_number
    job_id
    job_number
    payment_date
    myob_account_code_id
    myob_bank_account_code_id
    from_brand_id
    to_brand_id
    payment_total
    remaining_total
    invoice_total
    created_by
    created_date
    updated_by
    updated_date
  */